import { APIEndpoints } from "../../constants";
import {
  APIPost,
  APIPostFormData,
  getAuthHeaders,
  getAuthFormDataHeaders,
  APIResponse,
} from "../api/common.service";
import {
  CreateClassContentRequest,
  CreateClassContentResponseData,
  EditClassContentRequest,
  EditClassContentResponseData,
  COQLRequest,
  ClassContentSearchResponseData,
  GetClassContentByIdRequest,
  ClassContentDetail,
  PreviewLinkRequest,
  PreviewLinkResponseData,
  DownloadLinkRequest,
  DownloadLinkResponseData,
} from "../../types";

export function CreateClassContent(
  body: CreateClassContentRequest
): Promise<APIResponse<CreateClassContentResponseData>> {
  return getAuthHeaders().then((headers) =>
    APIPost<CreateClassContentResponseData>(
      APIEndpoints.CreateClassContent,
      headers,
      undefined,
      body as unknown as Record<string, unknown>
    )
  );
}

export function EditClassContent(
  body: EditClassContentRequest
): Promise<APIResponse<EditClassContentResponseData>> {
  return getAuthHeaders().then((headers) =>
    APIPost<EditClassContentResponseData>(
      APIEndpoints.EditClassContent,
      headers,
      undefined,
      body as unknown as Record<string, unknown>
    )
  );
}

export function SearchClassContent(
  body: COQLRequest
): Promise<APIResponse<ClassContentSearchResponseData>> {
  return getAuthHeaders().then((headers) =>
    APIPost<ClassContentSearchResponseData>(
      APIEndpoints.SearchClassContent,
      headers,
      undefined,
      body as unknown as Record<string, unknown>
    )
  );
}

export function GetClassContentById(
  body: GetClassContentByIdRequest
): Promise<APIResponse<ClassContentDetail>> {
  return getAuthHeaders().then((headers) =>
    APIPost<ClassContentDetail>(
      APIEndpoints.GetClassContentById,
      headers,
      undefined,
      body as unknown as Record<string, unknown>
    )
  );
}

export function GetPreviewLink(
  body: PreviewLinkRequest
): Promise<APIResponse<PreviewLinkResponseData>> {
  return getAuthHeaders().then((headers) =>
    APIPost<PreviewLinkResponseData>(
      APIEndpoints.GetPreviewLink,
      headers,
      undefined,
      body as unknown as Record<string, unknown>
    )
  );
}

export function GetDownloadLink(
  body: DownloadLinkRequest
): Promise<APIResponse<DownloadLinkResponseData>> {
  return getAuthHeaders().then((headers) =>
    APIPost<DownloadLinkResponseData>(
      APIEndpoints.GetDownloadLink,
      headers,
      undefined,
      body as unknown as Record<string, unknown>
    )
  );
}
